export const resolveClinicForUser = async (supabase, userId) => {
  try {
    // 1. Try as clinic owner
    const { data, error } = await supabase
      .from('clinics')
      .select('*')
      .eq('user_id', userId)
      .single();

    if (!error) return { clinic: data, error: null };

    // 2. If no rows (PGRST116), try as vet employee
    if (error.code === 'PGRST116') {
      const { data: vetData, error: vetError } = await supabase
        .from('vets')
        .select('clinic_id')
        .eq('user_id', userId)
        .single();

      if (vetError) return { clinic: null, error: 'NO_CLINIC_FOUND' };

      const { data: clinicData, error: clinicError } = await supabase
        .from('clinics')
        .select('*')
        .eq('id', vetData.clinic_id)
        .single();

      if (clinicError) return { clinic: null, error: 'CLINIC_FETCH_FAILED' };
      return { clinic: clinicData, error: null };
    }

    return { clinic: null, error: error.message };
  } catch (err) {
    return { clinic: null, error: err.message };
  }
};
